// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2E_XT","resendInfoText":"OnGoingPaymentBox_resendInfoText__2_ttV"};